import QuizQuestion from "./QuizQuestion";

export default QuizQuestion;
